import React from "react";

export type BABoxProps = React.HTMLAttributes<HTMLDivElement> & {
    children?: React.ReactNode;
    className?: string;
    sx?: React.CSSProperties; // better typed
};

const BABox = React.forwardRef<HTMLDivElement, BABoxProps>(
    ({ children, className = "", sx, style, ...rest }, ref) => {
        return (
            <div
                ref={ref}
                className={className}
                style={{ ...style, ...sx }}
                {...rest}
            >
                {children}
            </div>
        );
    }
);

BABox.displayName = "BABox";

export default BABox;
